module.exports = function() {
  return new Worker(__webpack_public_path__ + "ec4664498dac3f35fe5e.worker.js");
};